import { FileKind } from "../../../../define/FileKind";
import { BaseLocalListData } from "../../base/BaseLocalListData";

/** 子女数据 */
class ChildInfo{
    /** id */
    id: string = '';
    /** 资源id */
    icon: string = '';
    /** 名称 */
    name: string = '';
    /** 母亲id */
    motherId: string = '';
    /** 亲密度 */
    intimacy: number = 0;
    /** 成长阶段 */
    stage: number = 0;
    /** 当前阶段教育次数 */
    educationCount: number = 0;
    /** 每日花费 */
    everyDayCost: number = 0;
    /** 是否新人 */
    bNew: boolean = true;
    /** 是否是男孩 */
    bBoy: boolean = false;
    /** 是否放入府里 */
    bEnterMansion: boolean = false;
}

export default class ChildData extends BaseLocalListData {
    lists = new Map<string, ChildInfo>();

    maxId: number = 0;
   
    protected localKey: string = FileKind.SaveLocalDataKey.CHILD_DATA;

    createItem(key: string): ChildInfo {
        return this.createItemT<ChildInfo>(ChildInfo, key);
    }
}
